import React from "react";
import { launchGoogleAuth } from "../lib/authLib";
import { useSnackbar } from "../contexts/SnackbarContext";
import { Link } from "react-router-dom";

const Login = () => {
  const { showSnackbar } = useSnackbar();

  const handleLogin = async () => {
    try {
      const result = await launchGoogleAuth();
      window.open(result.url, "_self");
    } catch (error) {
      console.error("Error during Google authentication", error);
      // Show user-friendly error message
      if (error instanceof Error) {
        showSnackbar(error.message, "error");
      } else {
        showSnackbar("Failed to connect to the Cobutler API", "error");
      }
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col justify-center items-center px-4">
      <div className="w-full max-w-md bg-gray-800 rounded-lg shadow-xl overflow-hidden border border-gray-700">
        <div className="p-6 sm:p-8">
          <div className="text-center">
            <img
              src="/logo-dark.png"
              alt="Cobutler Logo"
              className="w-48 h-auto mb-6 mx-auto"
            />
            <h1 className="text-2xl font-bold mb-2 text-white">
              Welcome to Cobutler
            </h1>
            <p className="text-gray-300 mb-8">
              Sign in to access your dashboard
            </p>
          </div>

          <button
            onClick={handleLogin}
            className="w-full flex items-center justify-center gap-3 bg-blue-600 hover:bg-blue-700 text-white py-3 px-4 rounded-md transition-colors duration-200 font-medium"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M12.545,10.239v3.821h5.445c-0.712,2.315-2.647,3.972-5.445,3.972c-3.332,0-6.033-2.701-6.033-6.032s2.701-6.032,6.033-6.032c1.498,0,2.866,0.549,3.921,1.453l2.814-2.814C17.503,2.988,15.139,2,12.545,2C7.021,2,2.543,6.477,2.543,12s4.478,10,10.002,10c8.396,0,10.249-7.85,9.426-11.748L12.545,10.239z" />
            </svg>
            Sign in with Google
          </button>

          <div className="mt-6 text-center">
            <span className="text-gray-400 text-sm">
              Don't have an account?{" "}
              <Link
                to="/signup"
                className="text-blue-400 hover:text-blue-300 font-medium"
              >
                Sign up to get started
              </Link>
            </span>
          </div>

          <div className="mt-8 text-center">
            <a
              href="mailto:hello@cobutler.com"
              className="text-blue-400 hover:text-blue-300 text-sm flex items-center justify-center gap-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              Need help? Email us at hello@cobutler.com
            </a>
          </div>
        </div>

        <div className="bg-gray-700 px-6 py-4 text-center text-sm text-gray-300">
          <p>© {new Date().getFullYear()} Cobutler. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
